import Axios from 'axios';

export default {
  getStatistic() {
    return Axios.get('/actions/simple-google-analytics/default/statistic').then(response => response.data);
  },
};
